/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useCallback, useRef } from 'react';
import propTypes from 'prop-types';
import PageIndex from '../../../presentational/pageIndex';
import PaymentSettingDisplay from '../../../presentational/properties/payments/paymentSettingDisplay';
import PaymentModal from '../../../presentational/properties/payments/paymentModal';
import { useTranslation } from 'react-i18next';
import { fetchProperties, fetchResidentTransactions,
         fetchCurrentSubscription, newSubscription, fetchConfiguration } from '../../../misc/apiRequests';
import Exit from '../../../../assets/images/exit.svg';
import Checkmark from '../../../../assets/images/payments/check-solid.svg'
import Xmark from '../../../../assets/images/payments/xmark-solid.svg'
import Swal from 'sweetalert2';
import Loader from '../../../presentational/loader';
import CheckoutPage from './checkoutPage';
// import { propertiesData, transactionsData, subscriptionData } from '../../../misc/jsonData/propertyListingData'

const PropertyPayments = ({ user, handleMessagesModal, handleLoader, isLoading, handleModal }) => {
  const { t } = useTranslation();

  const [showPaymentForm, setShowPaymentForm] = useState(false);

  const [recentSubscription, setRecentSubscription] = useState(null);
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);

  const [rentedProperties, setRentedProperties] = useState([]);
  const [pageNumbRental, setPageNumbRental] = useState(1);
  const [maxPagesRental, setMaxPagesRental] = useState(1);
  const [perPageRental, setPerPageRental] = useState(5);

  const [selectedPayment, setSelectedPayment] = useState(null);
  const [paymentModalType, setPaymentModalType] = useState('owned');
  const [subscriptionPlanSelected, setSubscriptionPlan] = useState({});

  const [basicMonthlyCost, setBasicMonthlyCost] = useState(0.0);
  const [premiumMonthlyCost, setPremiumMonthlyCost] = useState(0.0);
  const [businessMonthlyCost, setBusinessMonthlyCost] = useState(0.0);
  const [eliteMonthlyCost, setEliteMonthlyCost] = useState(0.0);
  const [maxPropertiesBasic, setMaxPropertiesBasic] = useState(1);
  const [maxPropertiesPremium, setMaxPropertiesPremium] = useState(3);
  const [maxPropertiesBusiness, setMaxPropertiesBusiness] = useState(0);
  const [maxPropertiesElite, setMaxPropertiesElite] = useState(0);

  const SUBSCRIPTION_DURATIONS = [1, 3, 6, 12];
  const DEFAULT_SUBSCRIPTION_MONTHS = 3;

  const [showSubscriptionDetails, setShowSubscriptionDetails] = useState(false);

  const handleShowSubPlans = (planSelected) => {
    setShowSubscriptionPlans(planSelected)
  }

  // Handle Subscription plan. Billing is always monthly; `months` is how many
  // months are prepaid up front (1/3/6/12), so the charge is monthlyRate * months.
  const handleSubscriptionPlan = (planSelected, months = DEFAULT_SUBSCRIPTION_MONTHS) => {
    setShowSubscriptionPlans(false)

    let monthlyRate = '';
    switch (planSelected) {
      case 'basic':
        monthlyRate = basicMonthlyCost;
        break;
      case 'premium':
        monthlyRate = premiumMonthlyCost;
        break;
      case 'business':
        monthlyRate = businessMonthlyCost;
        break;
      case 'elite':
        monthlyRate = eliteMonthlyCost;
        break;
      default:
        monthlyRate = basicMonthlyCost;
    }

    const amount = monthlyRate * months;

    const plan = { subscription: { subscription_plan: planSelected,
                                  subscription_length: 'month',
                                  subscription_months: months,
                                  payment_amount: (Math.round(amount * 100) / 100).toFixed(2) } };

    setSubscriptionPlan(plan);
    setShowPaymentForm(true);
  };

  // Handles selection of property when property is clicked
  const handlePaymentSelect = (payment, paymentType = 'owned') => {
    setPaymentModalType(paymentType);
    setSelectedPayment(payment);
  };

  const handlePaymentModal = () => {
    setSelectedPayment(null);
  };

  // Populate all payment settings for rented properties as a tenant
  const populateSubscription = () => (
    <PaymentSettingDisplay
      key={recentSubscription.id}
      paymentInfo={recentSubscription}
      user={user}
      showSubscriptionPlans={showSubscriptionPlans}
      setShowSubscriptionPlans={setShowSubscriptionPlans}
      paymentType="subscription"
    />
  );

  // Populate all payment settings for rented properties as a tenant
  const populateTransactions = () => rentedProperties.map(transaction => (
    <PaymentSettingDisplay
      key={transaction.id}
      paymentInfo={transaction}
      user={user}
      handlePaymentSelect={handlePaymentSelect}
      paymentType="rented"
    />
  ));

  // Renders the 1/3/6/12 month duration choices for a plan, with the default
  // duration visually marked out
  const renderDurationOptions = (planKey, monthlyCost) => (
    <div className='flex-col mt-2'>
      {SUBSCRIPTION_DURATIONS.map(months => (
        <div
          key={months}
          className={`flex-row justify-content-between align-items-center mb-1 duration-option${months === DEFAULT_SUBSCRIPTION_MONTHS ? ' duration-option-default' : ''}`}
        >
          <div>
            <div>${(monthlyCost * months).toFixed(2)} / {months} {months === 1 ? t('month') : t('months')}</div>
            {months === DEFAULT_SUBSCRIPTION_MONTHS && <span className='text-grey size-0'>{t('most_popular')}</span>}
          </div>
          <button type='button' className='ml-1' onClick={() => handleSubscriptionPlan(planKey, months)}>{t('choose')}</button>
        </div>
      ))}
    </div>
  );

  const paymentFormModal = (
    <div className="modal">
      <div className="modal-content" style={{maxWidth: '900px', maxHeight: '1200px', minHeight: '620px'}}>
        <div style={{position: 'relative', width: '100%', height: '100%'}}>
          <CheckoutPage handleLoader={handleLoader} handleMessagesModal={handleMessagesModal}
            subscriptionPlanSelected={subscriptionPlanSelected} setShowPaymentForm={setShowPaymentForm}
          />
        </div>
      </div>
    </div>
  )

  const subPlanModal = (
    <div className="modal">
      <button
        id='navBackDrop'
        onClick={() => setShowSubscriptionPlans(false)}
      >
      </button>
      <div className="modal-content" style={{backgroundColor: 'transparent'}}>
        {showSubscriptionPlans === 'basic' && (
          <div className='flex-row justify-flex-center'>
            <div className='subscriber-plan'>
              <h3 className='mb-1'>{t('basic')}</h3>
              <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} {maxPropertiesBasic}
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1 text-red'>
                <img className='red-filter' src={Xmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
              </ul>
              {renderDurationOptions('basic', basicMonthlyCost)}
            </div>
          </div>
        )}
        {showSubscriptionPlans === 'premium' && (
          <div className='flex-row justify-flex-center'>
            <div className='subscriber-plan premium'>
              <h3 className='mb-1'>{t('premium')}</h3>
              <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} {maxPropertiesPremium}
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
              </ul>
              {renderDurationOptions('premium', premiumMonthlyCost)}
            </div>
          </div>
        )}

        {showSubscriptionPlans === 'business' && (
          <div className='flex-row justify-flex-center'>
            <div className='subscriber-plan business'>
              <h3 className='mb-1'>{t('business')}</h3>
              <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} {maxPropertiesBusiness}
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
              </ul>
              {renderDurationOptions('business', businessMonthlyCost)}
            </div>
          </div>
        )}

        {showSubscriptionPlans === 'elite' && (
          <div className='flex-row justify-flex-center'>
            <div className='subscriber-plan business'>
              <h3 className='mb-1'>{t('elite')}</h3>
              <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list_unlimited')}
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
              </ul>
              {renderDurationOptions('elite', eliteMonthlyCost)}
            </div>
          </div>
        )}
      </div>
    </div>
  )

  const subscriptionModal = (
    <div className="container-md">
      <div className="messages-container">
        <h3 className='text-white section-banner section-banner-purple'>Subscription Plans</h3>
        <p className='text-center mb-2'>
          Looking to post up listings for others to browse online?
        </p>
        <h3 className='mb-2'>{t('choose_plan')}</h3>
        <div className='subscription-plans-grid'>
          <div className='subscriber-plan'>
            <h3 className='mb-1'>{t('basic')}</h3>
            <div className='mb-2'>
              <span>Starts at</span>
              <br></br>
              <span><b>${basicMonthlyCost.toFixed(2)}</b> /{t('month')}</span>
            </div>
            <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} <b>{maxPropertiesBasic}</b>
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1 text-red'>
                <img className='red-filter' src={Xmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
            </ul>
            <button onClick={() => handleShowSubPlans('basic')} className='mt-1'>Get Started</button>
          </div>
          <div className='subscriber-plan premium'>
            <h3 className='mb-1'>{t('premium')}</h3>
            <div className='mb-2'>
              <span>Starts at</span>
              <br></br>
              <span><b>${premiumMonthlyCost.toFixed(2)}</b> /{t('month')}</span>
            </div>
            <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} <b>{maxPropertiesPremium}</b>
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
            </ul>
            <button onClick={() => handleShowSubPlans('premium')} className='mt-1'>Get Started</button>
          </div>
          <div className='subscriber-plan business'>
            <h3 className='mb-1'>{t('business')}</h3>
            <div className='mb-2'>
              <span>Starts at</span>
              <br></br>
              <span><b>${businessMonthlyCost.toFixed(2)}</b> /{t('month')}</span>
            </div>
            <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list')} <b>{maxPropertiesBusiness}</b>
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
            </ul>
            <button onClick={() => handleShowSubPlans('business')} className='mt-1'>Get Started</button>
          </div>
          <div className='subscriber-plan business'>
            <h3 className='mb-1'>{t('elite')}</h3>
            <div className='mb-2'>
              <span>Starts at</span>
              <br></br>
              <span><b>${eliteMonthlyCost.toFixed(2)}</b> /{t('month')}</span>
            </div>
            <ul>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                {t('allowed_to_list_unlimited')}
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Tenant Screening
              </li>
              <li className='mb-1'>
                <img src={Checkmark} style={{width: '14px', marginRight: '6px'}} alt='checkmark'></img>
                Featured Property Listings
              </li>
            </ul>
            <button onClick={() => handleShowSubPlans('elite')} className='mt-1'>Get Started</button>
          </div>
        </div>
        <div>
          <h3 className='mb-3'>{t('whyChooseTitle')}</h3>
          <p>
            <b>{t('whyChoose1Bold')}</b> – {t('whyChoose1Text')}
          </p>

          <p>
            <b>{t('whyChoose2Bold')}</b> – {t('whyChoose2Text1')}
            <br/>{t('whyChoose2Text2')}
            <br/>
            {t('whyChoose2Text3')}
          </p>

          <p>
            <b>{t('whyChoose3Bold')}</b> – {t('whyChoose3Text')}
          </p>

          <p>
            <b>{t('whyChoose4Bold')}</b> – {t('whyChoose4Text')}
          </p>
        </div>
      </div>
    </div>
  );

  // Grab API Configuration
  useEffect(() => {
    handleLoader(true);
    fetchConfiguration()
      .then(response => {
        if (response.success) {
          setMaxPropertiesBasic(response.record.max_properties);
          setMaxPropertiesPremium(response.record.max_properties_premium);
          setMaxPropertiesBusiness(response.record.max_properties_business);
          setMaxPropertiesElite(response.record.max_properties_elite);
          setBasicMonthlyCost(Number(response.record.basic_subscription_monthly_cost));
          setPremiumMonthlyCost(Number(response.record.premium_subscription_monthly_cost));
          setBusinessMonthlyCost(Number(response.record.business_subscription_monthly_cost));
          setEliteMonthlyCost(Number(response.record.elite_subscription_monthly_cost));
        }
        if (!response.success) {
          // handleModal(response.errors);
          Swal.fire({
            position: 'top-end',
            toast: true,
            timerProgressBar: true,
            icon: 'error',
            title: Array.isArray(response.errors) ? response.errors.join("\n") : response.errors,
            showConfirmButton: false,
            timer: 3000
          })
        }
        handleLoader(false);
      });
  }, [handleLoader, handleModal]);


  // Grab all current residential property transactions by current user
  useEffect(() => {
    handleLoader(true);
    const record = { per_page: perPageRental, page: pageNumbRental, };
    fetchResidentTransactions(record.per_page, record.page)
      .then(response => {
        if (response.success) {
          setRentedProperties(response.records);
          setMaxPagesRental(response.records_params.max_page || 1);
        }
        if (!response.success) handleModal(response.errors);
        handleLoader(false);
      });
  }, [handleLoader, handleModal, pageNumbRental, perPageRental]);

  // Grab current subscription
  useEffect(() => {
    handleLoader(true);
    fetchCurrentSubscription()
      .then(response => {
        if (response.success) {
          setRecentSubscription(response.subscription);
          // !response.subscription && setShowSubscriptionPlans(true)
        }
        if (!response.success) handleModal(response.errors);
        handleLoader(false);
      });
  }, [handleLoader, handleModal]);

  // useEffect(() => {

  // }, [paymentData])

    // Grab all FAKE DATA for properties posted by current user
    // useEffect(() => {
    //     handleLoader(true);
    //     setRecentSubscription(subscriptionData);
    //     const ownedProperties = propertiesData.filter(x => x.owner_id === user.id)
    //     const rentedProperties = transactionsData.filter(x => x.user_id === user.id)

    //     setProperties(ownedProperties);
    //     setMaxPagesOwned(1);
    //     setRentedProperties(rentedProperties);
    //     setMaxPagesRental(1);

    //     handleLoader(false);
    // }, [handleLoader, user.id]);

  return (
    <div className='acct-menu-container'>
      <h1>{t('f_payment')}</h1>
      {user?.roles?.includes('landlord') && <div className='mb-1'>
        <h3 className='text-white section-banner section-banner-grey'>{t('recent_sub')}</h3>

        <div className='d-flex flex-row justify-content-center mb-4'>
          {
            recentSubscription ? populateSubscription() :
            <span>No recent subscription information available</span>
          }
        </div>
        {showSubscriptionPlans && subPlanModal}
        {subscriptionModal}
        {showPaymentForm && paymentFormModal}
        {/* <button className='btn mt-1' onClick={() => setShowSubscriptionPlans(true)}>
          Purchase Subscription Plan
        </button> */}
      </div>}

      {user?.roles?.includes('citizen') && (
        <div className='mb-1'>
          <h3>{t('my_home_rental')}</h3>
          {/* <button type='button'>Search by address</button> */}
          {/* <form className='flex-row flex-start pb-1' onSubmit={handleSearchRental}>
            <input type='text'
              className='search-btn'
              value={searchRental}
              onChange={e => setSearchRental(e.target.value)}
              minLength="4"
              required
            />
            <button type="submit" className='button-search'>{t('search')}</button>
          </form> */}
          <div className='flex-row'>{populateTransactions()}</div>
          {maxPagesRental > 1 && (
            <div className='text-center'>
              <PageIndex setPage={setPageNumbRental} setPerPage={setPerPageRental} page={pageNumbRental} perPage={perPageRental} maxPages={maxPagesRental} />
            </div>
          )}
        </div>
      )}

      {selectedPayment && <PaymentModal info={selectedPayment} handleLoader={handleLoader} handleModal={handleModal} handlePaymentModal={handlePaymentModal} />}
    </div>
  );
};

PropertyPayments.propTypes = {
  user: propTypes.instanceOf(Object),
  handleMessagesModal: propTypes.func.isRequired,
  handleLoader: propTypes.func.isRequired,
  handleModal: propTypes.func.isRequired
};

export default PropertyPayments;
